import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function Z8() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');

    return (
        <div className={`d2x-Z8 ${css.d2xZ8} GtmModuleData-section`} data-section-id={css.d2xZ8} data-section-title={t('sec8_title')}>
            <div className="sec8">
                <div className="text-box">
                    <p className="title">{t('sec8_title')}</p>
                    <p className="desc">{t('sec8_desc')}</p>
                    <p className="tips">{t('sec8_tips')}</p>
                </div>
                <div className="img-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z8.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/z8.jpg')}
                        alt={t('sec8_title')}
                        aria-label={t('sec8_title')}
                    />
                </div>
            </div>
        </div>
    );
}
